import React, { useEffect, useRef, useState } from "react";

export const NewSealNumberComponent = React.forwardRef((props, ref) => {
  const { name, disabled, read_only, onChange, defaultValue } = props;

  // Using a ref to directly interact with the DOM element
  const inputRef = useRef(null);

  useEffect(() => {
    if (ref) {
      ref.current = inputRef.current; // Assigning the DOM element to the forwarded ref
    }
  }, [ref]);

  const formatLabel = (label) => {
    return label.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  };

  return (
    <div className="form-group new-seal-number">
      <label className="form-label">
        <span dangerouslySetInnerHTML={{ __html: formatLabel(props.data.label) }}></span>
        {props.data.required && <span className="label-required badge badge-danger">Required</span>}
      </label>
      <input
        ref={inputRef} // Using the ref here
        type="text"
        className="form-control"
        name={name}
        disabled={disabled}
        readOnly={read_only}
        value={defaultValue} // Controlled component
      />
    </div>
  );
});